export const TIMEOUTS = {
    INACTIVITY: 10 * 60 * 1000,
} as const;
